var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRechazado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 0c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12z",
    fill: "#f44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.419 15.006c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-3.005-3.006-3.005 3.006c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l3.005-3.006-3.005-3.006c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l3.005 3.006 3.005-3.006c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-3.005 3.006z",
    fill: "#fafafa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 0c-6.617 0-12 5.383-12 12s5.383 12 12 12v-10.586l-3.005 3.006c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l3.005-3.006-3.005-3.006c-.391-.391-.391-1.023 0-1.414.195-.195.451-.293.707-.293s.511.098.707.293l3.005 3.006z",
    fill: "#d43a2f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8.288 7.287c-.256 0-.512.098-.707.293-.391.391-.391 1.023 0 1.414l3.005 3.006-3.005 3.006c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l3.005-3.006v-2.828l-3.005-3.006c-.196-.195-.452-.293-.707-.293z",
    fill: "#dadada"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechazado);
export default __webpack_public_path__ + "static/media/rechazado.a92f6301ff88df717a46e1fad0b20c54.svg";
export { ForwardRef as ReactComponent };